<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title119"></a>
<div class="p-c"><span><strong class="b">FOR GLENDA</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429999946_ded01.vue?27928c2a